{
    "Policies_Bordereaux.title": "Bordereaux",
    "Policies_Bordereaux.filter.product": "Produit",
    "Policies_Bordereaux.filter.selectProduct": "Veuillez sélectionner un produit",
    "Policies_Bordereaux.table.product": "Produit",
    "Policies_Bordereaux.table.year": "Année",
    "Policies_Bordereaux.table.month": "Mois",
    "Policies_Bordereaux.table.count": "Nombre",
    "Policies_Bordereaux.table.download": "Télécharger",
    "Policies_Bordereaux.noData": "Aucune donnée de bordereau disponible pour le produit sélectionné"
}
